const adminValidateUsername = (postData: string) => {
    const errors: string[] = [];
    let isValid = false;

    if (postData.trim() === '') {
        errors.push('Username cannot be empty');
        isValid = false;
    }

    return { isValid, errors };
};

const adminValidatePassword = (postData: string) => {
    const errors: string[] = [];
    let isValid = false;

    if (postData.trim() === '') {
        errors.push('Password cannot be empty');
        isValid = false;
    }

    return { isValid, errors };
};

export{
    adminValidateUsername,
    adminValidatePassword
}